module.exports = __webpack_public_path__ + "static/media/iphone.f85a8026.png";